import React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import { Helmet } from 'react-helmet';

// 引入图片
import banner from '../images/banner.jpg';
import Lazada1 from '../images/Lazada1.jpg';
import Lazada2 from '../images/Lazada2.jpg';
import Lazada3 from '../images/Lazada3.jpg';
import Lazada4 from '../images/Lazada4.jpg';

// 页面容器
const LazadaContainer = styled.div`
  width: 100%;
`;

// Banner 区域
const BannerSection = styled.section`
  width: 100%;
  background-color: #0099ff;
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  margin-bottom: 0.5rem;
`;

const BannerImage = styled.div`
  width: 80%;
  height: 400px;
  background-image: url(${banner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    width: 95%;
    height: 200px;
  }
`;

// Welcome 区域
const WelcomeSection = styled.section`
  padding: 0 5rem 3rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 2rem 2rem;
  }
`;

const WelcomeTitle = styled.h2`
  font-size: 3rem;
  color: #0099ff;
  margin: 0 0 1rem 0;
  display: inline-block;
`;

const WelcomeText = styled.p`
  color: #333;
  line-height: 1.6;
  font-size: 1rem;
  max-width: 100%;
  margin: 0;
`;

// Lazada 标题栏
const LazadaHeader = styled.h3`
  font-size: 1.2rem;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.5rem;
  margin: 0 5rem 2rem;

  @media (max-width: 768px) {
    margin: 0 2rem 1.5rem;
  }
`;

// 展会图片网格
const LazadaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  padding: 0 5rem 3rem;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 768px) {
    padding: 0 2rem 2rem;
  }
`;

// 展会图片卡片
const LazadaCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

// 图片样式
const LazadaImage = styled.img`
  width: 100%;
  height: 400px;
  object-fit: cover;
  object-position: top left;
  display: block;

  @media (max-width: 768px) {
    height: 200px;
  }
`;

// ✅ 这里已经改成 20px 加粗
const LazadaCaption = styled.p`
  font-size: 20px;
  font-weight: bold;
  color: #666;
  margin: 0;
  text-align: center;
  padding: 10px 0.5rem;
`;

const LazadaPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Lazada - Wisdom Home Appliances</title>
        <meta name="description" content="Wisdom exhibition Lazada and company history" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <LazadaContainer>
        {/* 顶部 Banner */}
        <BannerSection>
          <BannerImage />
        </BannerSection>

        {/* Welcome 区域 */}
        <WelcomeSection>
          <WelcomeTitle>WELCOME</WelcomeTitle>
          <WelcomeText>
            To OEM and ODM consumer electronics, Home appliances, Small Home appliances, since 2006, we supply high quality and good service to our clients. Since 2019, we have started to sell our Wisdom brands products in Asia market by lazada. Now we have more than 500 SKU available for OEM and wholesale.
          </WelcomeText>
        </WelcomeSection>

        {/* Lazada 标题 */}
        <LazadaHeader>Lazada</LazadaHeader>

        {/* 展会图片网格 */}
        <LazadaGrid>
          <LazadaCard>
            <LazadaImage src={Lazada1} alt="2024 Global Sources Fair" />
            <LazadaCaption>Lazada-Southwisdom-Malaysia</LazadaCaption>
          </LazadaCard>
          <LazadaCard>
            <LazadaImage src={Lazada2} alt="2024 Global Sources Fair" />
            <LazadaCaption>Lazada-Southwisdom-Philippine</LazadaCaption>
          </LazadaCard>
          <LazadaCard>
            <LazadaImage src={Lazada3} alt="2019 Canton Fair" />
            <LazadaCaption>Lazada-Southwisdom-Singapore</LazadaCaption>
          </LazadaCard>
          <LazadaCard>
            <LazadaImage src={Lazada4} alt="2018 Hong Kong TDC Fair" />
            <LazadaCaption>Lazada-Southwisdom-Thailand</LazadaCaption>
          </LazadaCard>
        </LazadaGrid>
      </LazadaContainer>
    </Layout>
  );
};

export default LazadaPage;